// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-associate[data-v-7167e2b6]{padding:10px 0;background:#fff;box-shadow:0 2px 8px 0 rgba(0,0,0,.16);border-radius:4px;width:100%}.search-associate-item[data-v-7167e2b6]{padding:0 15px;list-style:none;text-align:left;line-height:40px;box-sizing:border-box}.search-associate-item>a[data-v-7167e2b6]{display:block;color:#222226}", ""]);
// Exports
module.exports = exports;
